import React, { useContext, useEffect, useState } from "react";
import { Product } from "../../../../models/home-rows";
import styles from "./mobileSlider.module.scss";
import { useSwipeable } from "react-swipeable";
import MobileSliderCard from "./mobileSliderCard";

type SwiperProps = {
  products: Product[];
  intervalTime: number;
};
export const MobileSlider = ({ products, intervalTime }: SwiperProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handlers = useSwipeable({
    onSwipedRight: () => handleNext(),
    onSwipedLeft: () => handlePrev(),
    delta: 5,
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: true
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prevSlide => (prevSlide + 1) % products.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [products.length, intervalTime]);

  const handlePrev = () => {
    setCurrentSlide(
      prevSlide => (prevSlide - 1 + products.length) % products.length
    );
  };

  const handleNext = () => {
    setCurrentSlide(prevSlide => (prevSlide + 1) % products.length);
  };

  return (
    <div className={styles.container} {...handlers}>
      <div className={` ${styles.poster}`}>
        {!!products &&
          products.length > 0 &&
          products.map((product, index) => (
            <MobileSliderCard
              currentSlide={currentSlide}
              product={product}
              index={index}
              key={product.id}
            />
          ))}
      </div>

      <div className={styles.pagination}>
        {!!products &&
          products.length > 0 &&
          products.map((product, index) => (
            <>
              {index === currentSlide ? (
                <div className={styles.activeIndex}>
                  <span className={styles.progress}></span>
                </div>
              ) : (
                <span
                  className={styles.point}
                  onClick={() => setCurrentSlide(index)}
                ></span>
              )}
            </>
          ))}
      </div>
    </div>
  );
};
